import {
  Dropdown,
  InteractiveIcon,
  List,
  Thumbnail,
} from '@bynder/design-system';
import { useAssignThemesetToGuide } from '../../../mutations/themesets';
import { useGuideThemesetId, useThemesets } from '../../../queries/themesets';
import { IconOpenInNew, IconTheming } from '@bynder/icons';
import { EXTERNAL_ROUTES } from '../../../constants/app';
import { Translate } from '@bynder/localization';
import { defaultBynderThemeset } from '../../../constants/themesets';

export const InspectorThemesetEditor: React.FC<{ guideId: string }> = ({
  guideId,
}) => {
  const { data: themesets } = useThemesets();
  const { data: guideThemesetId } = useGuideThemesetId(guideId);
  const assignThemesetMutation = useAssignThemesetToGuide(guideId);

  if (!themesets || !guideThemesetId) return null;

  const activeThemeset =
    themesets.find(themeset => guideThemesetId === themeset.id) ??
    defaultBynderThemeset;

  const handleAssignThemeset = (themesetId: string) => {
    assignThemesetMutation.mutate({ themesetId });
  };

  return (
    <>
      <List.Item
        thumbnail={<Thumbnail shape="square" icon={<IconTheming />} />}
        rightElements={
          <InteractiveIcon
            icon={<IconOpenInNew />}
            onClick={() =>
              window.open(EXTERNAL_ROUTES.THEMESET(guideThemesetId), '_blank')
            }
            label="View theme set"
          />
        }
      >
        <Translate id="GUIDE_INSPECTOR_PANEL.THEME_SET" />
      </List.Item>
      <List>
        <Dropdown
          trigger={({ isOpen, ...triggerProps }) => (
            <List.Item
              data-testid="changeThemeset"
              thumbnail={
                <Thumbnail
                  variant="content"
                  shape="circle"
                  backgroundColor={activeThemeset.cover.backgroundColor}
                  size="s"
                />
              }
              isSelected={isOpen}
              rightElements={<Dropdown.Arrow />}
              {...triggerProps}
            >
              {activeThemeset.label}
            </List.Item>
          )}
          position="bottom"
        >
          {themesets.map(themeset => (
            <Dropdown.ListItem
              key={themeset.id}
              onClick={() => handleAssignThemeset(themeset.id)}
              thumbnail={
                <Thumbnail
                  variant="content"
                  shape="circle"
                  backgroundColor={themeset.cover.backgroundColor}
                  size="s"
                />
              }
              isChecked={guideThemesetId === themeset.id}
              data-testid={themeset.id}
            >
              {themeset.label}
            </Dropdown.ListItem>
          ))}
        </Dropdown>
      </List>
    </>
  );
};
